import { FC, ReactElement } from 'react';

import { Typography } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface HeaderProps {
  headerLabel?: string;
  headerName?: string;
  headerSubtext?: string;
  rightContent?: ReactElement;
}
const Header: FC<HeaderProps> = ({
  headerLabel,
  headerName,
  headerSubtext,
  rightContent,
}) => (
  <div
    className={cn(
      'mb-5 flex w-full flex-col flex-wrap items-center justify-center px-8 text-center md:mb-0 md:flex-row md:pb-4 xl:flex-nowrap',
      !!rightContent && 'justify-between',
    )}
  >
    <div className={cn('hidden w-80', !!rightContent && 'xl:block')} />
    <div className="grow py-10 md:max-w-[calc(100%-var(--space-80))]">
      {headerLabel && (
        <Typography variant="overline1">{headerLabel}</Typography>
      )}
      {headerName && (
        <Typography data-testid="PageHeader" variant="h2">
          {headerName}
        </Typography>
      )}
      {headerSubtext && (
        <Typography variant="overline2">{headerSubtext}</Typography>
      )}
    </div>
    {rightContent && (
      <div className="mt-0 flex justify-center md:w-80 md:py-9 xl:mt-2 xl:justify-end">
        {rightContent}
      </div>
    )}
  </div>
);

export default Header;
